import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AuthAction } from '../../store/actions';

class Logout extends PureComponent {
  static propTypes = {
    logout: PropTypes.func,
  };

  render() {
    return (
      <button className="dropdown-item" onClick={this.props.logout}>
        <i className="fas fa-sign-out-alt mr-2"></i>
        Logout
      </button>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  logout: data => dispatch(AuthAction.logout(data)),
});

export default connect(null, mapDispatchToProps)(Logout);
